"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptiveOverlayController = void 0;
const constants_1 = require("@/constants");
const media_query_controller_1 = require("@/controllers/media-query-controller");
/**
 * 넓은 화면에서는 popover로, 좁은 화면에서는 sheet로 목록을 여는 컴포넌트(mm-select, mm-more-menu)의 열림 상태를 소유한다.
 * 두 표면은 backdrop·스크롤 잠금·포커스 가두기를 쥐는 방식이 달라 한 표면을 CSS로 갈아입힐 수 없으므로 표면 컴포넌트 자체를 갈아 끼운다.
 * 그래서 열림 상태는 두 표면이 나눠 갖지 않고 이 컨트롤러가 갖고, 호스트는 open·compact·trigger를 읽어 두 표면과 트리거에 내려준다.
 * 열림 상태를 이 컨트롤러가 소유하므로 트리거는 aria-controls로 표면을 가리키지 않고 호스트가 handleTriggerClick으로 직접 배선한다.
 * 걸면 표면의 DisclosureController가 같은 클릭을 또 토글하기 때문이다. 마지막으로 누른 트리거는 popover의 기준 요소가 된다.
 * 트리거·목록 템플릿은 호스트마다 달라 호스트가 그린다.
 */
class AdaptiveOverlayController {
    constructor(host) {
        this.host = host;
        this.isOpen = false;
        // Lit은 템플릿 리스너를 호스트를 this로 두고 부르므로, 템플릿에 넘기는 핸들러는 화살표 함수로 둔다.
        // 열림 상태를 이 컨트롤러가 소유하므로 호스트 트리거가 직접 연다. 트리거에는 aria-controls를 걸지 않는다.
        this.handleTriggerClick = (event) => {
            this.triggerElement = event.currentTarget;
            this.setOpen(!this.isOpen);
        };
        // popover·sheet는 외부 클릭·ESC·닫기 버튼으로 스스로 닫히므로, 표면이 디스패치하는 toggle 이벤트의 open 값으로 상태를 맞춘다.
        this.handleOverlayToggle = (event) => {
            this.setOpen(event.detail.open);
        };
        // 표면이 갈리면 트리거 배선도 새 표면으로 옮겨가므로, 열린 채로 넘어가지 않게 렌더 전에 닫는다.
        this.media = new media_query_controller_1.MediaQueryController(host, constants_1.MEDIA_QUERY.compact, () => {
            this.isOpen = false;
        });
    }
    get open() {
        return this.isOpen;
    }
    /** 마지막으로 누른 트리거. popover가 이 요소의 화면 좌표를 기준으로 놓인다. */
    get trigger() {
        return this.triggerElement;
    }
    /** 좁은 화면이라 sheet가 목록을 맡는지 여부 */
    get compact() {
        return this.media.matches;
    }
    close() {
        this.setOpen(false);
    }
    setOpen(open) {
        if (open === this.isOpen)
            return;
        this.isOpen = open;
        this.host.requestUpdate();
    }
}
exports.AdaptiveOverlayController = AdaptiveOverlayController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRhcHRpdmUtb3ZlcmxheS1jb250cm9sbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYWRhcHRpdmUtb3ZlcmxheS1jb250cm9sbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLDJDQUF5QztBQUN6QyxpRkFBMkU7QUFFM0U7Ozs7Ozs7R0FPRztBQUNILE1BQWEseUJBQXlCO0lBS3BDLFlBQW9CLElBQTRCO1FBQTVCLFNBQUksR0FBSixJQUFJLENBQXdCO1FBSHhDLFdBQU0sR0FBRyxLQUFLLENBQUE7UUE0QnRCLDhEQUE4RDtRQUM5RCxvRUFBb0U7UUFDcEUsdUJBQWtCLEdBQUcsQ0FBQyxLQUFZLEVBQUUsRUFBRTtZQUNwQyxJQUFJLENBQUMsY0FBYyxHQUFHLEtBQUssQ0FBQyxhQUE0QixDQUFBO1lBQ3hELElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUE7UUFDNUIsQ0FBQyxDQUFBO1FBQ0Qsc0ZBQXNGO1FBQ3RGLHdCQUFtQixHQUFHLENBQUMsS0FBcUMsRUFBRSxFQUFFO1lBQzlELElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTtRQUNqQyxDQUFDLENBQUE7UUFqQ0MseURBQXlEO1FBQ3pELElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSw2Q0FBb0IsQ0FBQyxJQUFJLEVBQUUsdUJBQVcsQ0FBQyxPQUFPLEVBQUUsR0FBRyxFQUFFO1lBQ3BFLElBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSyxDQUFBO1FBQ3JCLENBQUMsQ0FBQyxDQUFBO0lBQ0osQ0FBQztJQUVELElBQUksSUFBSTtRQUNOLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQTtJQUNwQixDQUFDO0lBRUQsb0RBQW9EO0lBQ3BELElBQUksT0FBTztRQUNULE9BQU8sSUFBSSxDQUFDLGNBQWMsQ0FBQTtJQUM1QixDQUFDO0lBRUQsZ0NBQWdDO0lBQ2hDLElBQUksT0FBTztRQUNULE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUE7SUFDM0IsQ0FBQztJQUVELEtBQUs7UUFDSCxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQ3JCLENBQUM7SUFhTyxPQUFPLENBQUMsSUFBYTtRQUMzQixJQUFJLElBQUksS0FBSyxJQUFJLENBQUMsTUFBTTtZQUFFLE9BQU07UUFFaEMsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLENBQUE7UUFDbEIsSUFBSSxDQUFDLElBQUksQ0FBQyxhQUFhLEVBQUUsQ0FBQTtJQUMzQixDQUFDO0NBQ0Y7QUEvQ0QsOERBK0NDIn0=